/**
 * article模块接口列表
 */
// import base from "../base"; // 导入接口域名列表
import axios from "@/request/http"; // 导入http中创建的axios实例

const pay = {
  offerPayApi(params) {
    return axios.post(`/order-api/offer-pay`, params);},
  payInfoApi(params) {
    return axios.post(`/order-api/pay-info`, params);},
  commentApi(params) {
    return axios.post(`/user/comment`, params);},
  getCardAndPackages: params => {
    return axios.post('cc/getCardAndPackages', params)},
  cardPay: params => {
    return axios.post('cc/charge/pay/info', params)},
  openCardPayInfo: params => {return axios.post('/cc/charge/pay/info', params)},
  offerPayDeskApi: params => {
    return axios.post('/order-api/offer-pay-cash-desk', params)},
  getCodeApi: params => {
    return axios.post('/order-api/get-check-code', params)},
  getPayCheckpi: params => {
    return axios.post('/order-api/pay-check', params)},
  getPackageDetail: params => {
    return axios.post('/cc/card/package/detail', params)},
  chagerInfoApi: params => {
    return axios.post('/cc/chager/info', params)}
};

export default pay;
